// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__1lOpT","primary":"Button_primary__3n8ov"};